var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentIconMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "46px",
    viewBox: "0 0 66 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "payment-icon\\mastercard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marketing-material's",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-478.000000, -539.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mastercard-",
    transform: "translate(478.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.992615,0.5 C63.6842129,0.5 64.310303,0.781274947 64.7639284,1.23385341 C65.2183357,1.687212 65.5,2.31268939 65.5,3.00044415 L65.5,42.9995558 C65.5,43.6897024 65.2191609,44.3144414 64.7657764,44.7667795 C64.3117138,45.2197942 63.6845798,45.5 62.992615,45.5 L3.00738502,45.5 C2.3157871,45.5 1.68969699,45.2187251 1.23607159,44.7661466 C0.781664252,44.312788 0.5,43.6873106 0.5,42.9995558 L0.5,3.00044415 C0.5,2.31029755 0.780839051,1.68555861 1.23422358,1.23322047 C1.68828617,0.78020583 2.31542019,0.5 3.00738502,0.5 Z",
    id: "Rectangle-Copy-4",
    stroke: "#E6E7E8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mc_symbol",
    transform: "translate(13.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 39.8151515,
    height: 25.9701149
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5F00",
    x: 14.6575758,
    y: 4.5245977,
    width: 10.5030303,
    height: 16.917931
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7393939,12.9850575 C15.7367568,9.68425331 17.2732148,6.56556145 19.9060606,4.52758621 C15.4332698,1.06093502 9.01016282,1.56588274 5.15072663,5.68756569 C1.29129045,9.80924864 1.29129045,16.1638548 5.15072663,20.2855378 C9.01016282,24.4072207 15.4332698,24.9121684 19.9060606,21.4455172 C17.2723769,19.4068948 15.735825,16.2869104 15.7393939,12.9850575 Z",
    id: "Path",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5360606,20.0825078 L36.5360606,19.3794775 L36.7027273,19.3794775 L36.7027273,19.234023 L36.3060606,19.234023 L36.3060606,19.3794775 L36.4627273,19.3794775 L36.4627273,20.0825078 L36.5360606,20.0825078 Z M37.3060606,20.0825078 L37.3060606,19.234023 L37.1860606,19.234023 L37.0460606,19.8400836 L36.9060606,19.234023 L36.7860606,19.234023 L36.7860606,20.0825078 L36.8727273,20.0825078 L36.8727273,19.4400836 L37.0027273,19.9915987 L37.0927273,19.9915987 L37.2227273,19.4400836 L37.2227273,20.0825078 L37.3060606,20.0825078 Z",
    id: "Shape",
    fill: "#F79E1B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5575758,12.9850575 C37.5575758,17.1042286 35.1725518,20.8617576 31.4156834,22.6618074 C27.6588151,24.4618572 23.1895727,23.9884054 19.9060606,21.4425287 C22.5377577,19.4028233 24.0743313,16.2845461 24.0743313,12.9835632 C24.0743313,9.68258035 22.5377577,6.56430313 19.9060606,4.5245977 C23.1895727,1.97872109 27.6588151,1.50526928 31.4156834,3.30531907 C35.1725518,5.10536886 37.5575758,8.86289782 37.5575758,12.982069 L37.5575758,12.9850575 Z",
    id: "Path",
    fill: "#F79E1B"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIconMastercard);
export default __webpack_public_path__ + "static/media/payment-icon-mastercard.127787dc2cf9811bc945ed6b830d7cdc.svg";
export { ForwardRef as ReactComponent };